<template>
  <div class="body">
    <h2 class="mb-4">Información del usuario</h2>
    <!-- <div class="row pb-4 mt-2">
      <div class="col-4 pr-0 ">
        <div class="mp-form-text">
          <div class="input-container readonly">
            <input type="text" name="code" v-model="user.businessName" :placeholder="user.businessName" reandoly />
            <label>Agencia</label>
          </div>
          <span class="disabled">No editable se genera automáticamente</span>
        </div>
      </div>
      <div class="col-4 pr-0">
        <div class="mp-form-text">
          <div class="input-container readonly">
            <input type="text" name="city" v-model="user.city" required  reandoly/>
            <label>Ciudad</label>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row pb-4 mt-2">
      <div class="col-4 pr-0">
        <div class="mp-form-text">
          <div class="input-container readonly">
            <input type="text" name="numberDocument" v-model="user.documentType" required reandoly />
            <label>Tipo de documento</label>
          </div>
        </div>
      </div>
      <div class="col-4 pr-0">
        <div class="mp-form-text">
          <div class="input-container readonly">
            <input type="text" name="numberDocument" v-model="user.document" required reandoly />
            <label>Nro. de documento</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row pb-4 mt-2">
      <div class="col-4 pr-0">
        <div class="mp-form-text">
          <div class="input-container readonly">
            <input type="text" name="name" v-model="user.firstName" required reandoly />
            <label>Nombres</label>
          </div>
        </div>
      </div>
      <div class="col-4 pr-0">
        <div class="mp-form-text">
          <div class="input-container readonly">
            <input type="text" name="name" v-model="user.lastName" required reandoly />
            <label>Apellidos</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row pb-4 mt-2">      
      <div class="col-4 pr-0">
        <div class="mp-form-text">
          <div class="input-container readonly">
            <input type="text" name="phone" v-model="endDate" required readonly />
            <label>Fecha de expiración de licencia</label>
          </div>
        </div>
      </div>
      <div class="col-4 pr-0">
        <div class="mp-form-text">
          <div class="input-container">
            <input type="text" name="phone" v-model="user.phone" required />
            <label>Teléfono</label>
          </div>
        </div>
      </div>
      <!-- <div class="col-4 pr-0 mp-form-text">
        <div class="input-container with-icon">          
          <DatePicker
            type="date"
            required
            format="YYYY-MM-DD"
            value-type="format"
            :lang="lang"
            placeholder="Fecha de Cumpleaños"
            v-model="user.birthdate"
            :clearable="false"/>
        </div>
      </div> -->
    </div>
    <div class="row pb-4 mt-2">
      <div class="col-4 pr-0">
        <div class="mp-form-text">
          <div class="input-container">
            <input type="text" value="" name="email" v-model="user.email" required />
            <label>Correo</label>
          </div>
        </div>        
      </div>
      <div class="col-2" v-if="user.emailVerified === 0">
        <button class="mp__btn color-dark" @click="checkEmail">Verificar</button>
      </div>
    </div>
    <button class="save" @click="updateProfile()">Actualizar Datos</button>
    <div class="row py-4 mt-2">
      <div class="col-4 pr-0">
        <div class="mp-form-text">
          <div class="input-container readonly">
            <input type="password" value="***************************" name="password" readonly />
            <label>Contraseña</label>
          </div>
        </div>
      </div>      
      <div class="col-2">
        <button class="mp__btn color-dark" @click="modalChangePassword.show = true">Actualizar</button>
      </div>
    </div>
    <ModalLoading :showModal="showModalLoading" />
    <ReservationModal
      :showModal="modalCheckEmail.show"
      :icon="modalCheckEmail.icon"
      :title="modalCheckEmail.title"
      :message="modalCheckEmail.message"
      :buttonText="modalCheckEmail.buttonText"
      @closeModalRegister="modalCheckEmail.show = false"
    />
    <ModalChangePassword
      :email="user.email"
      :showModal="modalChangePassword.show"
      @response="responseUpdate"
      @Cancel="modalChangePassword.show = $event"
    />
    <!-- <LoadingJoinnus v-if="loading"></LoadingJoinnus> -->
  </div>
</template>
<script>
import api from '../api';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
  components: {
    ModalLoading: () => import('@/components/modals/loading.vue'),
    ModalChangePassword: () => import('@/components/ModalChangePassword.vue'),
  },
  data() {
    return { 
      loading:true,
      showModalLoading: false,
      lang: 'es',
      modalCheckEmail: {
        show: false,
        icon: 'check',
        title: 'Se envió el correo correctamente',
        message: '',
        buttonText: 'Entendido',
      },
      modalChangePassword: {
        show: false,
      },
      endDate:'DD/MM/YYYY',
      user: {
        city: 'lima',
        cityId: 1,
        countryId: 1,
        documentType: '',
        document: '',
        email: '',
        userAdmin: 0,
        firstName: '',
        lastName: '',
        phoneCode: null,
        phone: '',
        birthdate: null,
        profilePicture: null,
        emailVerified: 1,
        rucDni: '000000000000',
        businessName: 'agencia',
        flagOrganizer: 0,
        userCode: null,
        type: null,
      },
    };
  },
  methods: {
    async getInformation() {
      this.loading = true;
      let {roles} = JSON.parse(localStorage.getItem('userAuth'));
      for(let role of roles) {
        if(role.name === 'agency'){
            this.endDate = this.getChangeFormatDate(role.endDate);
        }
      }
      let { data, status } = await api.getUserInformation();
      if (status) {
        this.user = data;
      }
      this.loading = false;
    },
    getChangeFormatDate(date) {
      if (date) {
        const dateComponents = date.split(/[/ -]/);
        if (dateComponents.length >= 3) {
          const [year, month, day] = dateComponents;
          const formattedDateStr = `${day}/${month}/${year}`;
          return formattedDateStr;
        } else {
          return '-';
        }
      } else {
        return '-';
      }
    },
    async checkEmail() {
      this.showModalLoading = true;
      let { status } = await api.checkEmail(this.user.email);
      if (status) {
        this.showModalLoading = false;
        // this.user.emailVerified = 1;
        this.modalCheckEmail.show = true;
      } else {
        this.getError();
      }
    },
    async updateProfile() {
      this.showModalLoading = true;
      const payload = {
        phone: this.user.phone,
        email: this.user.email,
      };
      let { status,message } = await api.updateProfile(payload);
      if (status) {
        this.showModalLoading = false;
        this.modalCheckEmail.icon = 'Check';
        this.modalCheckEmail.title = 'Cambio éxitoso';
        this.modalCheckEmail.message = 'Tu datos ha sido actualizados correctamente.';
        this.modalCheckEmail.buttonText = 'Entendido';
        this.modalCheckEmail.show = true;
      } else {
        this.showModalLoading = false;
        this.modalCheckEmail.icon = 'warning';
        this.modalCheckEmail.title = '¡Oops! Algo salió mal.';
        this.modalCheckEmail.message = message;
        this.modalCheckEmail.buttonText = 'Volver a intentar';
        this.modalCheckEmail.show = true;
      }
    },
    getError() {
      this.showModalLoading = false;
      this.modalCheckEmail.icon = 'warning';
      this.modalCheckEmail.title = '¡Oops! Algo salió mal.';
      this.modalCheckEmail.buttonText = 'Volver a intentar';
      this.modalCheckEmail.show = true;
    },
    responseUpdate(event) {
      const { message, status } = event;
      this.modalChangePassword.show = false;
      if (status) {
        this.modalCheckEmail.icon = 'Check';
        this.modalCheckEmail.title = 'Cambio éxitoso';
        this.modalCheckEmail.message = 'La contraseña ha sido actualizada correctamente.';
        this.modalCheckEmail.buttonText = 'Entendido';
        this.modalCheckEmail.show = true;
      } else {
        this.modalCheckEmail.icon = 'warning';
        this.modalCheckEmail.title = '¡Oops! Algo salió mal.';
        this.modalCheckEmail.buttonText = 'Volver a intentar';
        this.modalCheckEmail.message = message;
        this.modalCheckEmail.show = true;
      }
    },
  },
  mounted() {
    this.getInformation();
  },
};
</script>
<style lang="scss" scoped>
.body {
  display: flex;
  flex-direction: column;
  h2 {
    font-weight: 900;
    font-size: 1.25rem;
  }
  .disabled {
    color: #96a7b9;
    font-size: 0.75rem;
    font-weight: 500;
  }
  .save {
    display: flex;
    height: 3rem;
    padding: 0.5rem 2.5rem;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    border-radius: 1.5rem;
    background-color: #00e0b1;
    border: none;
    width: fit-content;
    font-size: 0.875rem;
    font-weight: 600;
  }
}
.mx-datepicker {
  width: 100%;
}
::v-deep .mx-icon-calendar,
::v-deep .mx-icon-clear {
  right: 50px;
  font-size: 1.5rem;
}
::v-deep .mp-form-text .input-container.with-icon input {
  padding: 1.25rem 0.75rem;
}
</style>
